import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=19e450dc&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=ts"
export * from "./Inbox.vue?vue&type=script&lang=ts"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=19e450dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e450dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e450dc')) {
      api.createRecord('19e450dc', component.options)
    } else {
      api.reload('19e450dc', component.options)
    }
    module.hot.accept("./Inbox.vue?vue&type=template&id=19e450dc&scoped=true", function () {
      api.rerender('19e450dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Inbox.vue"
export default component.exports